import branch from "./branch";
import department from "./department";
import accounting from "./accounting";
import user from "./user";
import category from "./category";
import templates from "./templates";
import salesTaxConfiguration from "./sales-tax-configuration";
import dependedField from './depended-field';

export default {
  namespaced: true,
  state: {},
  modules: {
    branch,
    department,
    accounting,
    user,
    category,
    templates,
    salesTaxConfiguration,
    dependedField,
  }
}
